export default "__VITE_ASSET__Cot_PlRq__"